import axios from 'axios';
import { API_URL } from '../config/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const profileService = {
  // Get complete user profile with seller info
  getProfile: async () => {
    const response = await api.get('/profile');
    return response.data;
  },

  // Update basic user info
  updateBasicInfo: async (data) => {
    const response = await api.put('/profile/basic', data);
    return response.data;
  },

  // Update profile (alias for admin profile page)
  updateProfile: async (data) => {
    // Map the data fields to match backend expectations
    const mappedData = {
      companyName: data.name || data.companyName,
      phone: data.phone,
      avatar: data.avatar,
      country: data.country || data.location,
      email: data.email
    };
    const response = await api.put('/profile/basic', mappedData);
    return response.data;
  },

  // Update seller profile
  updateSellerProfile: async (data) => {
    const response = await api.put('/profile/seller', data);
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    const response = await api.put('/profile/password', {
      currentPassword,
      newPassword,
      confirmPassword
    });
    return response.data;
  },

  // Upload image
  uploadImage: async (imageType, imageUrl) => {
    const response = await api.post('/profile/upload-image', {
      imageType,
      imageUrl
    });
    return response.data;
  },

  // Delete media (snapshot or brochure)
  deleteMedia: async (type, index) => {
    const response = await api.delete(`/profile/media/${type}/${index}`);
    return response.data;
  }
};

export default profileService;
